/*
# Base styles: opinionated defaults (_base)
*/


html,
button,
input,
select,
textarea {
	color: $colour-base;
	font-family: $font-base;
}

body.site {
	background-color: $colour-background;
	font-family: $font-base;
	font-size: rem($font-size, 16);
	line-height: 1.4;
	margin: 0;
	padding: 0;
	// word-wrap: break-word;
}

body.site > img[width="1"] {
  display: block;
}

// Remove text-shadow in selection highlight: h5bp.com/i
// These selection declarations have to be separate.
// Customize the background color to match your design.
::-moz-selection {
	background: #b3d4fc;
	text-shadow: none;
}

::selection {
	background: #b3d4fc;
	text-shadow: none;
}

// A better looking default horizontal rule
hr {
	display: block;
	height: 1px;
	border: 0;
	border-top: 1px solid #ccc;
	margin: 1em 0;
	padding: 0;
}


// Remove the gap between images and the bottom of their containers: h5bp.com/i/440
img {
	vertical-align: middle;
}

// Remove default fieldset styles.
fieldset {
	border: 0;
	margin: 0;
	padding: 0;
}

/*
 * Allow only vertical resizing of textareas.
 */

textarea {
	resize: vertical;
}

/*
 * Text Reset
 */
p, h1, h2, h3, h4, h5, h6 {
	margin: 0;

	+ * {
		margin-top: 1.4em !important; // Line height
	}
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
	font-family: $font-header;
}

h1, .h1 {
	// font-size: rem($font-size-xl);
	font-family: $font-header-bold;
	font-size: rem(50);
	font-weight: 700;

	@include min(768px) {
		font-size: rem(70);
	}
}
h2, .h2 {
	font-family: $font-header-bold;
	color: $colour-highlight;
	font-size: rem(30);
	font-weight: 500;

	@include min(768px) {
		font-size: rem(40);
	}
}
h3, .h3 {
	color: $colour-highlight;
	font-size: rem(20);
	font-weight: 700;
	text-transform: none;

	@include min(768px) {
		font-size: rem(30);
	}
}
h4, .h4 {
	color: $colour-highlight;
	font-size: rem(16);
	font-weight: 700;

	@include min(768px) {
		font-size: rem(18);
	}
}
h5, .h5 {
	font-size: rem($font-size);
	font-weight: 700;
}
h6, .h6 {
	font-size: rem($font-size);
	font-weight: 400;
}
p {
	line-height: 1.75;
	font-weight: 500;
}

/*
 * Links
 */
a {
	color: $colour-link;
	transition: color 0.3s;

	&:hover {
		color: darken($colour-alt, 10%);
	}
}
[rel="external"] {
	&:after {
		background-image: url(/site/images/icon/alt/external.svg);
		background-size: contain;
		content: '';
		display: inline-block;
		width: 10px;
		height: 10px;
		vertical-align: middle;
		margin-left: 0.1em;
	}
}
.lnk-noexternal {
	&:after {
		content: none;
	}
}


/* Text Alignment */
.justifyleft 	{ text-align: left; }
.justifyright 	{ text-align: right; }
.justifyfull 	{ text-align: justify; }
.justifycentre 	{ text-align: center; }



/* ==========================================================================
   Chrome Frame prompt
   ========================================================================== */

.chromeframe {
	margin: 0.2em 0;
	background: #ccc;
	color: #000;
	padding: 0.2em 0;
}


/* ==========================================================================
   Helper classes
   ========================================================================== */

/*
 * Image replacement
 */

.ir {
	background-color: transparent;
	border: 0;
	overflow: hidden;

	&:before {
		content: "";
		display: block;
		width: 0;
		height: 100%;
	}
}

/*
 * Hide from both screenreaders and browsers: h5bp.com/u
 */

.hidden {
	display: none !important;
	visibility: hidden;
}


.hide {
	display: none;
}

/*
 * Hide only visually, but have it available for screenreaders: h5bp.com/v
 */

.visuallyhidden {
	border: 0;
	clip: rect(0 0 0 0);
	height: 1px;
	margin: -1px;
	overflow: hidden;
	padding: 0;
	position: absolute;
	width: 1px;
}

/*
 * Extends the .visuallyhidden class to allow the element to be focusable
 * when navigated to via the keyboard: h5bp.com/p
 */

.visuallyhidden.focusable:active,
.visuallyhidden.focusable:focus {
	clip: auto;
	height: auto;
	margin: 0;
	overflow: visible;
	position: static;
	width: auto;
}

/*
 * Hide visually and from screenreaders, but maintain layout
 */

.invisible {
	visibility: hidden;
}

/*
 * Aspect Ratio Image
 */

.aspect-ratio-image {
    min-height: 0;
    width: 100%;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    position: relative;
    z-index: 2;
    overflow: hidden;
    display: block;
    text-decoration: none;

    &::before {
        content: '';
        display: block;
        height: 0;
        min-height: 0;
        width: 100%;
        z-index: 0;
        // padding-bottom: 66.84%;
    }

    &::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        // background: linear-gradient(59.64deg, rgba(0, 0, 0, 0.5) 0%, rgba(0, 0, 0, 0) 100%);
    }

    &.no-gradient::after {
        content: none;
    }
}

/*
 * Icons
 */

.icon {
    display: inline-block;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    font-size: 0;
}

.icon-location-mark {
    width: 14px;
    height: 20px;
    background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAxNCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNi45OTk3MSAwQzMuMTQwMjYgMCAwIDMuMzAzMTggMCA3LjM2MzI3IDAgOC40MjIzLjIwNjA2OCA5LjQzMzQ0LjYxMjE3MyAxMC4zNjg4YzEuNzUwMTE3IDQuMDI4NCA1LjEwNTU4NyA4LjI4MTUgNi4wOTI1MzcgOS40ODg5LjA3Mzk1LjA5MDMuMTgxNzUuMTQyMy4yOTUxOS4xNDIzLjExMzQ1IDAgLjIyMTI1LS4wNTIuMjk1MTktLjE0MjMuOTg2NTYtMS4yMDcyIDQuMzQyMDEtNS40NjAxIDYuMDkyNzEtOS40ODg5LjQwNjMtLjkzNTM2LjYxMjItMS45NDY1LjYxMjItMy4wMDU1M0MxMy45OTk2IDMuMzAzMTggMTAuODU5NCAwIDYuOTk5NzEgMHptMCAxMS4xODc4Yy0yLjAwNDg0IDAtMy42MzYwNy0xLjcxNTg4LTMuNjM2MDctMy44MjQ3MyAwLTIuMTA5MDYgMS42MzEyMy0zLjgyNDkyIDMuNjM2MDctMy44MjQ5MnMzLjYzNjA5IDEuNzE1ODYgMy42MzYwOSAzLjgyNDkyYy4wMDAyIDIuMTA4ODUtMS42MzEwNiAzLjgyNDczLTMuNjM2MDkgMy44MjQ3M3oiIGZpbGw9IiMwMDAiLz48L3N2Zz4=');
}

.icon-black-phone {
    width: 20px;
    height: 20px;
    background-image: url('data:image/svg+xml;base64,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');
}

.icon-black-email {
    width: 22px;
    height: 20px;
    background-image: url('data:image/svg+xml;base64,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');
}

/*
 * sr-only
 */
.sr-only {
	position: absolute;
	width: 1px;
	height: 1px;
	padding: 0;
	margin: -1px;
	overflow: hidden;
	clip: rect(0, 0, 0, 0);
	white-space: nowrap;
	border-width: 0;
}